var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgReset = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 -960 960 960",
    width: 20,
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M401-155q-93-25-151-100t-58-171q0-51 15-98.5t47-85.5q10-11 25-10.5t26 11.5q10 10 10 24.5t-9 25.5q-22 29-32 63.5T264-425q0 71 42.5 126.5T417-223q12 4 19.5 13t7.5 21q0 17-13 28t-30 6Zm157 1q-16 5-29-6.5T516-189q0-12 8-21t19-13q69-21 111-78.5T696-431q0-90-63.5-152.5T478-646h-3l16 16q11 11 10 25t-12 25q-11 11-25.5 11T439-580l-77-76q-5-5-7.5-12.5T352-684q0-7 3-13.5t8-11.5l78-78q11-11 25-11t25 11q11 11 10.5 25.5T491-736l-16 18h3q121 0 205.5 83.5T768-431q0 97-58 174T558-154Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReset, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reset.229f5351.svg";
export { ForwardRef as ReactComponent };